(function() {
  var RxOptions, yearUtil,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  RxOptions = App.loadClass('grower::viewmodels/placement/seed_options/RxOptions');

  yearUtil = require('resources/assets/coffee/Core/utils/year');

  exports.RxPlanFactory = (function() {
    function RxPlanFactory() {
      this.create = bind(this.create, this);
    }

    RxPlanFactory.prototype.create = function(field, spp_handler, callback) {
      var brands, multiHybridAspect, options, ref, ref1, ref2, ref3, ref4, ref5, ref6, refuge, rx_options, solver_variables, yg;
      brands = [];
      refuge = null;
      if (field.hybrid_selection() != null) {
        brands.push({
          name: 'Brand 1',
          id: field.hybrid_selection().id
        });
      }
      if (field.low_yield_hybrid_selection() != null) {
        brands.push({
          name: 'Brand 2',
          id: field.low_yield_hybrid_selection().id
        });
      }
      if (field.refuge_selection() != null) {
        brands.push({
          name: 'Refuge',
          id: field.refuge_selection().id
        });
      }
      multiHybridAspect = spp_handler.getFieldAspectByName(field.id, 'Multi-Hybrid Rx Plan');
      solver_variables = {
        min_pop: parseInt((ref = spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop')) != null ? ref.value : void 0),
        max_pop: parseInt((ref1 = spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop')) != null ? ref1.value : void 0),
        max_num_pops: parseInt((ref2 = spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Num Pops')) != null ? ref2.value : void 0),
        min_pop_diff: parseInt((ref3 = spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop Diff')) != null ? ref3.value : void 0),
        max_pop_diff: parseInt((ref4 = spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop Diff')) != null ? ref4.value : void 0)
      };
      yg = spp_handler.getFieldAspectByName(field.id, 'Yield Goal');
      options = {
        field: field,
        year: yearUtil.salesYear(),
        crop: spp_handler.cropID,
        crop_name: spp_handler.cropName,
        brands: brands,
        refuge: refuge,
        dual_hybrid: (ref5 = multiHybridAspect != null ? multiHybridAspect.value : void 0) != null ? ref5 : false,
        solver_variables: solver_variables,
        yield_goal: (ref6 = yg != null ? yg.value : void 0) != null ? ref6 : null,
        spp: spp_handler,
        spp_id: spp_handler.sppID,
        from_state: 'grower.placement'
      };
      rx_options = new RxOptions(options);
      window.RxStorage = rx_options;
      $(window).trigger('spp.add-planting-rx-plan');
      spp_handler.dialog.hide();
      $(window).off('rx:completed');
      $(window).on('rx:completed', (function(_this) {
        return function(e, data) {
          return callback(data);
        };
      })(this));
    };

    return RxPlanFactory;

  })();

}).call(this);
